/**
 * Logo do portal HUB (comercial/admin).
 * Troque o import abaixo quando houver arte dedicada do HUB.
 */
import hubLogo from '../brand.webp'

export default hubLogo
